module.exports = __webpack_public_path__ + "assets/img/index-partner5.fd28e104.jpg";